export enum EDocumentType {
  IMAGE_360 = 'Image360',
  IMAGE = 'Image',
  VIDEO = 'Video',
  FILE = 'File',
}
